export default __webpack_public_path__ + "static/media/sessions.d946564b.png";